import { memo, useState } from "react";
import PlanningManager from "./PlanningManager";
import PlanningManagerRight from "./PlanningManagerRight";
import { CalendarProvider, useCalendar } from "../Stores/CalendarProvider";
import { useStyles } from "@webapps/styles";

const Planning = ({
  infoMembers, classe, training, idParam, from,
  setOpenDeletePeriods,
  onDeletePeriods,
  setOnDeletePeriods
}) => {

  const ISCLASSAUTHORIZED = true;

  const { classes } = useStyles(styles);
  const [isDownloadingPlanning, setIsDownloadingPlanning] = useState(false);
  const [displayPlanningToExport, setDisplayPlanningToExport] = useState(false);

  const handleGeneratePDFWithNode = () => {
    setDisplayPlanningToExport(true);
    setIsDownloadingPlanning(true);
  };

  return (
    <CalendarProvider>
      <div className={classes.calendarProvider}>
        <PlanningManager
          classroomId={idParam}
          isClassAuthorized={ISCLASSAUTHORIZED}
          from={from}
          students={infoMembers}
          classroomName={classe?.label}
          trainingName={training?.label}
          trainingDegree={training?.degree?.label}
          classe={classe}
          setOpenDeletePeriods={setOpenDeletePeriods}
          onDeletePeriods={onDeletePeriods}
          setOnDeletePeriods={setOnDeletePeriods}
          handleGeneratePDFWithNode={handleGeneratePDFWithNode}
          isDownloadingPlanning={isDownloadingPlanning}
          setIsDownloadingPlanning={setIsDownloadingPlanning}
          displayPlanningToExport={displayPlanningToExport}
          setDisplayPlanningToExport={setDisplayPlanningToExport}
        />
        {!(from === "student") && <PlanningManagerRight
          setOpenDeletePeriods={setOpenDeletePeriods}
          handleGeneratePDFWithNode={handleGeneratePDFWithNode}
          isDownloadingPlanning={isDownloadingPlanning}
        />}
      </div>
    </CalendarProvider>
  )
}

const styles = () => ({
  calendarProvider: {
    display: "flex",
    gap: "30px",
    width: "100%",
  }
});

export default memo(Planning);